var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"router_container"},[_c('Header'),_c('Sider'),_c('section',{staticClass:"router-content"},[_c('div',{staticClass:"wrap_router"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }